import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { mapStateToProps } from "../../redux/reducers";
import { connect } from "react-redux";
import { getVendorHistoryDetail } from '../../redux/actionTypes/vendordetails';
import { convertUTCDateToLocalDate, formatPhoneNumber } from "../../utils/globalMethods";
import CommonLoading from "../common/components/commonLoading";
  
const theme = createTheme({
    typography: {
      h6: {
        fontFamily: "Texta-bold",
      },
      subtitle1: {
        fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
        fontSize: 20,
      },
    },
  });

const VendorHistoryDetail = (props) => { 
    const [isLoading, setIsLoading] = useState();
    useEffect(() => {
        const payload = {
            "role" : "ADMIN",
            "vendorId" : props?.row?.id,
            "vendorType": props?.vendorType,
            "createTs":props?.row?.createTime
        };
        props.getVendorHistoryDetail(payload);
    }, [props?.row?.id,props?.row?.createTime,props.vendorDetails.refreshKey,isLoading]);

    useEffect(() => {
         const { loading } =  props?.vendorDetails?.vendorHistoryDetail;
        if (  props.vendorDetails.vendorHistoryDetail.isHIPVendor === "Y" && props.vendorDetails.vendorHistoryDetail.hipInfo.createTs) {
            props.setVendorAddtInfo((prevState) => ({
                ...prevState,
                [props.vendorDetails.vendorHistoryDetail.hipInfo.createTime]: props.vendorDetails.vendorHistoryDetail.hipInfo }));
                
            }
            setIsLoading(loading);
      }, [props?.vendorDetails?.vendorHistoryDetail?.hipInfo?.createTs]);

    useEffect(() => {
        const { loading } =  props?.vendorDetails?.vendorHistoryDetail;
        if (props.vendorDetails.vendorHistoryDetail.isCSAVendor === "Y" && props?.vendorDetails?.vendorHistoryDetail?.csaInfo?.createTs) {
            props.setVendorAddtInfo((prevState) => ({
                ...prevState,
                [props?.vendorDetails?.vendorHistoryDetail?.csaInfo?.createTime] : props.vendorDetails.vendorHistoryDetail.csaInfo }));
        }
        setIsLoading(loading);
    },[props?.vendorDetails?.vendorHistoryDetail?.csaInfo?.createTs]);

    useEffect(() => {
        setIsLoading(false);
    },[props.vendorDetails.vendorHistoryDetail]);

    return (
        <Grid container className="collapsibleTable" spacing={2}> 
             {isLoading && <CommonLoading />}
        <ThemeProvider theme={theme}>
            <Grid item xs={10}>
                <Typography variant="h5" display="inline" className="resText text-capitalize" gutterBottom component="div">
                    Vendor Info for DTA Communications
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" gutterBottom component="div">
                    First Name
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.firstName ? props.vendorAddtInfo[props?.row?.createTime]?.firstName : '-'}
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" gutterBottom component="div">
                    Last Name
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.lastName ? props.vendorAddtInfo[props?.row?.createTime]?.lastName : '-'}
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" gutterBottom component="div">
                    Email Address
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo?.[props?.row?.createTime]?.primaryEmail ? props.vendorAddtInfo?.[props?.row?.createTime]?.primaryEmail : '-'}
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" gutterBottom component="div">
                    Mobile#
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.primaryMobile ? formatPhoneNumber(props.vendorAddtInfo[props?.row?.createTime]?.primaryMobile) : '-'}
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h6" gutterBottom component="div">
                    Registered Date
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.createTs ? convertUTCDateToLocalDate(props.vendorAddtInfo[props?.row?.createTime]?.createTs) : '-'}
                </Typography>
            </Grid>
            {/* {props?.showVendorHistoryDetails && */}
            <Grid item xs={3}>
            <Typography variant="h6" gutterBottom component="div">
                Verified Date
            </Typography>
                {/* {vendorInfo?.verifiedTs ? convertUTCDateToLocalDate(vendorInfo?.verifiedTs) : '-'} */}
                {(props.vendorAddtInfo[props?.row?.createTime]?.isActive==="Y") ? (
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.verifiedTs ? convertUTCDateToLocalDate(props.vendorAddtInfo[props?.row?.createTime]?.verifiedTs) : '-'}
              </Typography> ):"-"}
            </Grid>
            {/* } */}
            { props?.vendorDetails?.vendorHistoryDetail?.isHIPVendor === "Y" ? (
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                    Additional Contact Info
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.additionalContactInfo ? props.vendorAddtInfo[props?.row?.createTime]?.additionalContactInfo : "-"}
                </Typography>
            </Grid>) : (
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                    Admin Notes
                 </Typography>
                <Typography variant="subtitle1" gutterBottom>
                {props.vendorAddtInfo[props?.row?.createTime]?.additionalContactInfo ? props.vendorAddtInfo[props?.row?.createTime]?.additionalContactInfo : "-"}
                </Typography>
            </Grid> )}
                <Grid item xs={10}>
                    <Typography variant="h5" display="inline" className="resText" gutterBottom component="div">
                        Vendor Info for Public display
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom component="div">
                        Email
                        </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        {props?.vendorAddtInfo?.[props?.row?.createTime]?.publicEmail ? props?.vendorAddtInfo[props?.row?.createTime]?.publicEmail : '-'}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom component="div">
                        Mobile#
                        </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        {props?.vendorAddtInfo?.[props?.row?.createTime]?.publicMobile ? formatPhoneNumber(props?.vendorAddtInfo[props?.row?.createTime]?.publicMobile) : '-'}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom component="div">
                        Website
                        </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        {props?.vendorAddtInfo[props?.row?.createTime]?.publicWebsite ? props?.vendorAddtInfo[props?.row?.createTime]?.publicWebsite : '-'}
                    </Typography>
                </Grid>
                {props?.vendorDetails?.vendorHistoryDetail?.isHIPVendor === "Y"  ? (
                <>
                <Grid item xs={4}>
                    <Typography variant="h6" gutterBottom component="div">
                        Products
                        </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                    {props.vendorAddtInfo[props?.row?.createTime]?.products ? props.vendorAddtInfo[props?.row?.createTime]?.products : '-'}
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="h6" gutterBottom component="div">
                        Description
                        </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                    {props.vendorAddtInfo[props?.row?.createTime]?.businessDesc ? props.vendorAddtInfo[props?.row?.createTime]?.businessDesc : '-'}
                    </Typography>
                </Grid>
                </>) : (
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom component="div">
                        Notes for CSA
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                    {props.vendorAddtInfo[props?.row?.createTime]?.products ? props.vendorAddtInfo[props?.row?.createTime]?.products : '-'}
                    </Typography>
                </Grid> )}
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom component="div">
                        Photo
                        </Typography>
                    <Typography variant="subtitle1" gutterBottom component="div" nowrap={'true'}>
                    { props.vendorAddtInfo[props?.row?.createTime]?.publicPhoto && (<img src={props.vendorAddtInfo[props?.row?.createTime]?.publicPhoto} className="img-thumbnail" />)}  
                    </Typography>
                </Grid>
               
            </ThemeProvider>
        </Grid>
    )
}

VendorHistoryDetail.propTypes = {
    row: PropTypes.object.isRequired,
    showVendorHistoryDetails : PropTypes.bool,
    vendorDetails: PropTypes.object,
    getVendorHistoryDetail: PropTypes.func,
    vendorAddtInfo: PropTypes.object,
    setVendorAddtInfo: PropTypes.func,
    vendorType: PropTypes.string,
    vendorDetailsArray: PropTypes.func,


};

function mapDispatchToProps(dispatch) {
    return {
        getVendorHistoryDetail:(payload) => dispatch(getVendorHistoryDetail(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorHistoryDetail);